import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public navOpen = signal(false);

  toggleNav() {
    this.navOpen.set(!this.navOpen());
  }
  openNav() {
    this.navOpen.set(true);
  }
  closeNav() {
    this.navOpen.set(false);
  }
}
